<template>
  <!-- 回款记录详情 -->
  <div>
    <div class="main">
      <div class="titleText">回款记录（{{ dataValue.id }}）</div>
      <a-row class="row" v-for="(item, index) in detailsObj" :key="index">
        <a-col v-for="(el, ind) in item" :key="ind" :span="el.span">
          <div class="label">
            <div>{{ el.label }}</div>
            <span v-if="!el.slot" class="value">{{ dataValue[el.value] }}</span>
            <span
              v-else-if="el.slot === 'backStatusSlot'"
              class="value"
            >{{ dataValue[el.value] === 0 ? '未回款' : '已回款' }}</span>
            <span v-else-if="el.slot === 'backInvoiceSlot'" class="value">
              <a-tag v-if="dataValue[el.value] === 0" color="orange">未开票</a-tag>
              <span v-else-if="dataValue[el.value] === 1">
                <a-tag color="green">已开票</a-tag>
                <span
                  v-if="priShow"
                  style="color:#0079FE;margin:0 10px;cursor:pointer;"
                  @click="backInvoiceClick"
                >{已生成对应的开票记录}</span>
              </span>
              <a-tag v-else-if="dataValue[el.value] === 2">无需开票</a-tag>
            </span>
            <span
              v-else-if="el.slot === 'dateSlot'"
              class="value"
            >{{ dataFilter(dataValue[el.value]) }}</span>
            <span
              v-else-if="el.slot === 'dictDataSlot'"
              class="value"
            >{{ getDictName(el.listName, dataValue[el.value]) }}</span>
            <span v-else-if="el.slot === 'backMoney'" class="value">
              {{parseFloat(dataValue[el.value]).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
              <span
                style="margin: 0 10px;"
              >({{dealBigMoney(dataValue[el.value])}})</span>
            </span>
            <span v-else-if="el.slot === 'backCxMoney'" class="value">
              {{parseFloat(dataValue[el.value]).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
              <span
                style="margin: 0 10px;"
              >({{dealBigMoney(dataValue[el.value])}})</span>
            </span>
            <span
              v-else-if="el.slot === 'projectName'"
              @click="isProject(dataValue, 'project')"
              class="value onClickStyle"
              style="color:#0079FE;"
            >{{ dataValue[el.value] }}</span>
            <span
              v-else-if="el.slot === 'customerName'"
              @click="isProject(dataValue, 'customerName')"
              class="value onClickStyle"
              style="color:#0079FE;"
            >{{ dataValue[el.value] }}</span>
            <!-- <div v-else-if="el.slot === 'checkDataSlot'" class="value" style="width: 98%;">
              <audit-process-vue ref="auditRef" style="width: 100%;text-align:left;font-weight: 400;"/>
            </div>-->
            <a-table
              v-else-if="el.slot === 'payBackListSlot' && tableData && tableData.length > 0"
              bordered
              size="small"
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :rowKey="(record,index)=>{return index}"
              style="width: 85%;"
            />
            <div v-else-if="el.slot === 'fileIdsSlot'" style="width: 85%;">
              <upload-attachment
                v-if="dataValue.fileIds"
                ref="uploadRef"
                :upload-if="false"
                :upload-if-no="false"
              />
              <span v-else>暂无附件</span>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { dealBigMoney } from '@/utils/common'
import auditProcessVue from '@/views/common/auditProcess.vue'
import uploadAttachment from '@/views/common/Upload.vue'
// import {getCustomerNameById, getProjectNameById, getContractNameById} from '../../../utils/index'
export default {
  provide () {
    return {
      formData: this
    }
  },
  data () {
    return {
      dictData: {},
      dataValue: {},
      priShow: false,
      resData: [],
      detailsObj: [
        [
          {
            label: '对应项目:',
            value: 'projectName',
            span: 24,
            slot: 'projectName'
          }
        ],
        [
          {
            label: '对应客户:',
            value: 'customerName',
            span: 24,
            slot: 'customerName'
          }
        ],
        [
          {
            label: '公司账户:',
            value: 'companyAccount',
            span: 24,
            slot: 'dictDataSlot',
            listName: 'comAccountObj'
          }
        ],
        [
          {
            label: '合同订单:',
            value: 'contractName',
            span: 24
          }
        ],
        [
          {
            label: '款项日期:',
            value: 'backDate',
            span: 12,
            slot: 'dateSlot'
          },
          {
            label: '期次:',
            value: 'period',
            span: 12
          }
        ],
        [
          {
            label: '回款金额:',
            value: 'backMoney',
            span: 24,
            slot: 'backMoney'
          }
        ],
        [
          {
            label: '冲销金额:',
            value: 'backCxMoney',
            span: 24,
            slot: 'backCxMoney'
          }
        ],
        [
          {
            label: '计业绩金额:',
            value: 'backYjMoney',
            span: 12
          },
          {
            label: '计业绩备注:',
            value: 'bz',
            span: 12
          }
        ],
        [
          {
            label: '回款方式:',
            value: 'backPayMode',
            span: 12,
            slot: 'dictDataSlot',
            listName: 'returnedMoneyMethodsObj'
          },
          {
            label: '回款类别:',
            value: 'backClassify',
            span: 12,
            slot: 'dictDataSlot',
            listName: 'returnedMoneyTypeObj'
          }
        ],
        [
          {
            label: '负责人:',
            value: 'dutyPerson',
            span: 12
          },
          {
            label: '所有者:',
            value: 'backOwner',
            span: 12
          }
        ],
        [
          {
            label: '备注:',
            value: 'backRemark',
            span: 24
          }
        ],
        [
          {
            label: '是否开票:',
            value: 'backInvoice',
            span: 24,
            slot: 'backInvoiceSlot'
          }
        ],
        [
          {
            label: '对应计划:',
            value: 'payBackList',
            span: 24,
            slot: 'payBackListSlot'
          }
        ],
        [
          {
            label: '创建人:',
            value: 'creator',
            span: 24
          }
        ],
        [
          {
            label: '抄送对象:',
            value: 'userName',
            span: 24
          }
        ],
        // [
        //   {
        //     label: '审核记录:',
        //     value: 'checkData',
        //     span: 24,
        //     slot: 'checkDataSlot'
        //   }
        // ],
        [
          {
            label: '附件列表:',
            value: 'fileIds',
            span: 24,
            slot: 'fileIdsSlot'
          }
        ]
      ],
      tableData: [],
      columns: [
        {
          width: '32%',
          align: 'center',
          title: '计划日期',
          dataIndex: 'backDate'
        },
        {
          width: '32%',
          align: 'center',
          title: '计划额',
          dataIndex: 'backMoney'
        },
        {
          width: '32%',
          align: 'center',
          title: '计划冲销额',
          dataIndex: 'backCxMoney'
        }
      ],
      billVisibles: false
    }
  },
  components: { auditProcessVue, uploadAttachment },
  mounted () {
    this.$emit('onClickView')
  },
  methods: {
    dealBigMoney,
    setFormData (rowVal) {
      this.dataValue = rowVal
      // getCustomerNameById(this.dataValue.customerId).then(res => {
      //   this.$set(this.dataValue, 'customerName', res)
      // })
      // getProjectNameById(this.dataValue.projectId).then(res => {
      //   this.$set(this.dataValue, 'projectName', res)
      // })
      // getContractNameById(this.dataValue.contractId).then(res => {
      //   this.$set(this.dataValue, 'contractName', res)
      // })
      this.tableData = rowVal.payBackList
      this.dictData = this.$store.state.account.dictData
      // 获取审核记录数据
      // this.$nextTick(() => {
      //   this.$refs.auditRef[0].getData(rowVal.id, rowVal.checkStatus, 4)
      // })
      // 获取附件
      if (this.dataValue.fileIds) {
        let fileList = this.dataValue.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef[0].getFile(fileList)
        })
      }
      this.$get('/invoice/list', { planRecordId: this.dataValue.id }).then(res => {
        if (res.data.status === 1) {
          this.resData = res.data.data.rows
          if (this.dataValue.backInvoice === 1 && this.resData.length !== 0) {
            this.priShow = true
          } else {
            this.priShow = false
          }
        } else {
          this.$message.error(`查询${this.$tree([], 'financialManage/billingRecords/index')}失败`)
        }
      })
    },
    getDictName (objVal, val) {
      if (val) {
        if (this.dictData[objVal]) {
          return this.dictData[objVal][val]
        }
      }
    },
    dataFilter (val) {
      if (val) return val.slice(0, 10)
    },
    isProject (value, name) {
      // this.$emit('projectChange', value)
      console.log(value, name)
      this.$emit('projectChange', value, name)
    },
    backInvoiceClick () { // 点击查看开票记录
      this.billVisibles = true
      this.$nextTick(() => {
        // this.$refs.billingRef.setForm(resData)
        this.$emit('datasChange', this.resData[0], 'financialManage/billingRecords/viewBill.vue', this.$tree([], 'financialManage/billingRecords/index'))
      })
      // this.$emit('close')
      // this.$get('/invoice/list', { planRecordId: this.dataValue.id }).then(res => {
      //   if (res.data.status === 1) {
      //     let resData = res.data.data.rows[0]
      //     if (resData) {
      //       this.billVisibles = true
      //       this.$nextTick(() => {
      //         // this.$refs.billingRef.setForm(resData)
      //         this.$emit('datasChange', res.data.data.rows[0], 'financialManage/billingRecords/viewBill.vue', this.$tree([], 'financialManage/billingRecords/index'))
      //       })
      //     } else {
      //       this.$message.warning(`暂无${this.$tree([], 'financialManage/billingRecords/index')}`)
      //     }
      //   } else {
      //     this.$message.error(`查询${this.$tree([], 'financialManage/billingRecords/index')}失败`)
      //   }
      // })
    },
    closeBill () {
      this.billVisibles = false
    }
  }
}
</script>

<style  lang="less"  scoped>
.main {
  width: 100%;
  .row {
    padding: 10px 40px;
    border-bottom: 1px dashed #e8e8e8;
    .label {
      color: #7b7d81;
      vertical-align: middle;
      display: flex;
      span:first-child {
        font-weight: 600;
      }
      div:first-child {
        font-weight: 600;
        width: 80px;
        letter-spacing: 1px;
        text-align: right;
        margin-right: 10px;
      }
    }
    .value {
      color: #333;
      vertical-align: middle;
      padding-left: 8px;
    }
  }
}
/deep/ .ant-modal {
  padding-bottom: 0;
  box-sizing: border-box;
  .ant-modal-content {
    min-height: auto;
  }
}
.summary-item {
  text-align: center;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #fafafa;
  .summary-item-value {
    font-size: 24px;
    font-weight: 600;
    color: #1890ff;
    font-size: 16px;
    .amount {
      font-size: 26px;
      font-weight: bold;
    }
  }
  .summary-item-text {
    font-size: 14px;
    color: #666;
  }
}
/deep/ .ant-table-thead > tr > th {
  background-color: #efefef !important;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}
/deep/ .main .row .label div:first-child {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/contractManage/paymentRecord/show.vue